import { useQuery } from '@tanstack/react-query';
import { screenDetailTypes } from '@libs/constants';
import mpx from '../../../actions/mpx_data';
import playerService from '../../../helpers/bitmovinPlayer';
import browser from '../../../helpers/browser';
import h, { getCountry } from '../../../helpers/common';

export const useMpxItemFeedQuery = (id, otherOptions) =>
    useQuery({
        queryKey: ['mpx-feed-item', id],
        queryFn: async () => {
            const response = await mpx.getItemFeed(id);
            return response;
        },
        ...otherOptions,
    });

export const usePlaylistQuery = (content) =>
    useQuery({
        queryKey: ['series-playlist', content?.Id],
        enabled:
            !!content &&
            (content.programType === screenDetailTypes.SERIES || content.programType === screenDetailTypes.EPISODE),
        queryFn: async () => {
            const seriesId = content.programType === screenDetailTypes.SERIES ? content.Id : content.seriesId;
            const seasons = await mpx.getSeasons(seriesId, `{PC}{${getCountry()}}`);
            return seasons;
        },
    });

const generatePlaylistStreamUrl = (streamString, isSafari) => {
    // This regex correctly extracts the first URL for HLS and the second for DASH from a typical SMIL response.
    const streamREGX = streamString.match(/(http[s]?:[^{}]+)/gi);
    if (!streamREGX) return streamString; // Fallback
    // For Safari (HLS) use the first match, for others (DASH) use the second if it exists.
    return isSafari ? streamREGX[0] : streamREGX[1] || streamREGX[0];
};

export const useSeasonEpisodesQuery = (seasonId, content) =>
    useQuery({
        queryKey: ['season-episodes', seasonId, content?.Id],
        // This query will only run if we have a valid seasonId.
        enabled: !!seasonId && !!content,
        queryFn: async () => {
            // No need for extra checks here, `enabled` flag handles it.
            const isSafari = browser.isSafari();
            const episodes = await mpx.getEpisodes(seasonId);
            try {
                const mappedEpisodes = episodes.map((e) => ({
                    ...e,
                    source: {
                        // TODO: remove after testing
                        // drm: isSafari ? playerService.getSafariDRMConfig() : playerService.getOtherDRMConfig(),
                        poster: h.getImagizerUrl(e.image_landscape),
                        hls: isSafari ? generatePlaylistStreamUrl(e.streamingUrl, isSafari) : undefined,
                        dash: !isSafari ? generatePlaylistStreamUrl(e.streamingUrl, isSafari) : undefined,
                    },
                    title: e.text,
                    poster: h.getImagizerUrl(e.image_landscape),
                }));
                return mappedEpisodes;
            } catch (e) {
                // It's good practice to re-throw the error for react-query to catch
                throw e;
            }
        },
    });
